(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ridge-related"]) return;
  try {
    
document.querySelectorAll('[data-ridge-related]').forEach(section => {
  const load = async () => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-ridge-related]');
      if (content?.querySelector('.product-card')) section.replaceChildren(...content.childNodes);

    } catch (error) {}
  };
  if (!('IntersectionObserver' in window)) { load(); return; }
  const observer = new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.disconnect();
    load();
  }, {rootMargin: '200px'});
  observer.observe(section);
});

  } catch(e) { console.error(e); }
})();
})();
